import axios from 'axios';
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, DEFAULT_REFRESH_INTERVAL_MS, REFRESH_TIMESTAMP_KEY, USE_BEARER } from '../constants/constants2';
import { setAuthorizedEvent } from '../App';

const axiosRequest = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL2,
});

const setBearerHeaders = () => {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY);
  return USE_BEARER ? { headers: { Authorization: 'Bearer ' + token } } : {};
};

const handleError = async (err, errCb) => {
  if (err?.response?.status === 401) {
    refreshTokens({ refresh_token: localStorage.getItem(REFRESH_TOKEN_KEY) });
  }
  const msg = err?.response?.data;
  if (msg) {
    errCb?.(msg);
  } else {
    errCb?.({ error: err?.name + ' ' + err?.message, type: 'ServerError' });
  }
};

export const refreshTokens = async (refresh_token) => {
  const headers = setBearerHeaders();
  await axiosRequest
    .post('auth/refresh', refresh_token, headers)
    .then((res) => {
      updateTokens(res.data.access_token, res.data.refresh_token);
      setAuthorizedEvent(true);
    })
    .catch((err) => {
      if (err?.response?.status === 401) {
        setAuthorizedEvent(false);
      }
      var msg = err?.response?.data;
      if (msg) {
        console.log(JSON.stringify(msg));
      } else {
        console.log('server missing or no internet');
      }
    });
};

const updateTokens = async (access_token, refresh_token) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, access_token);
  localStorage.setItem(REFRESH_TOKEN_KEY, refresh_token);
  localStorage.setItem(REFRESH_TIMESTAMP_KEY, (Date.now() + DEFAULT_REFRESH_INTERVAL_MS).toString());
};

export const saveUser = async (user, dataCb, errCb) => {
  await axiosRequest
    .post('auth/save', user)
    .then((res) => {
      dataCb?.(res);
      updateTokens(res.data.access_token, res.data.refresh_token);
    })
    .catch((err) => {
      const msg = err?.response?.data;
      if (msg) {
        errCb?.(msg);
      } else {
        errCb?.({ error: err?.name + ' ' + err?.message, type: 'ServerError' });
      }
    });
};

export const getInstructionsApi2 = async (dataCb, errCb) => {
  const headers = setBearerHeaders();
  await axiosRequest
    .get('instructions/get', headers)
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      handleError(err, errCb);
    });
};

export const addInstructionApi2 = async (inst, dataCb, errCb) => {
  const headers = setBearerHeaders();
  await axiosRequest
    .post('instructions/add', inst, headers)
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      handleError(err, errCb);
    });
};

export const editInstructionApi2 = async (instr, dataCb, errCb) => {
  const headers = setBearerHeaders();
  await axiosRequest
    .patch('instructions/edit', instr, headers)
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      handleError(err, errCb);
    });
};

export const getPermitApi2 = async (dataCb, errCb) => {
  const headers = setBearerHeaders();
  await axiosRequest
    .get('instructions/permission', headers)
    .then((res) => {
      dataCb(res.data);
    })
    .catch((err) => {
      handleError(err, errCb);
    });
};
